module.exports = __webpack_public_path__ + "static/img/nosotros_foto2.ecc0f86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/nosotros_foto2.png
// module id = 19
// module chunks = 0